var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.items),function(item){return _c('span',{key:item.text},[(item.to)?[(item.to)?_c('router-link',{staticClass:"btn-link",attrs:{"to":item.to}},[_vm._v(_vm._s(item.text))]):_vm._e(),_vm._v(" / ")]:_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(item.text))])],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }